<ul class="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0 mt-2">
    <li><a routerLink="/" fragment="about" class="nav-link px-2">o nas</a></li>
    <li><a routerLink="/" fragment="contact" class="nav-link px-2">kontakt</a></li>
    <li>
        <button class="mx-2" color="primary" mat-stroked-button routerLink="/auth/login" matTooltip="Login to app"
                matTooltipPosition="right">Zaloguj <i class="fa-solid fa-right-to-bracket"></i></button>
    </li>
</ul>
